﻿export default class BasketSendOffer {
    constructor(vm) {
        this.vm = vm;
    }

    get(event) {
        let trackingObject = null;

        switch (event) {
            case 'basket-send-offer-qq-button-click':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': `${this.vm.type} prisberegner`,
                    'eventAction': '02 vælg dækning - send beregning',
                    'eventLabel': 'send beregning',
                    'eventValue': '0',
                    'eventNoninteraction': true,
                    'data': null
                };
                break;
            case 'basket-send-offer-qq-basket-button-click':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'beregnerkurv',
                    'eventAction': '03 kurv send beregning',
                    'eventLabel': this.vm.products,
                    'eventValue': '0',
                    'eventNoninteraction': true,
                    'data': null
                };
                break;
            case 'basket-send-offer-landing-page-button-click':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'Send beregning landingpage',
                    'eventAction': `CTA klik - ${this.vm.buttonText}`,
                    'eventLabel': 'Log på Min side',
                    'eventValue': '0',
                    'eventNoninteraction': true,
                    'data': null
                };
                break;
            case 'basket-send-offer-landing-page-cta-click':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'Send beregning landingpage',
                    'eventAction': `CTA klik - ${this.vm.buttonText}`,
                    'eventLabel': 'Eksisterende medlem',
                    'eventValue': '0',
                    'eventNoninteraction': true,
                    'data': null
                };
                break;
        }

        return trackingObject;
    }
}
